import { ref, useContext } from "@nuxtjs/composition-api";
import useCatalogNav from "./useCatalogNav";
import useCategoryAggs from "./useCategoryAggs";
function getPageAggs(query) {
  const { page, ...rest } = query;
  const aggs = {
    filters: {},
    sorting: {},
    limit: 15
  };
  Object.entries(rest).forEach(([key, value]) => {
    if (key.startsWith("order"))
      aggs.sorting[key] = value;
    else aggs.filters[key] = typeof value === "string" ? [value] : value;
  });
  return aggs;
}
function useFetchCategory() {
  const { error, ssrContext, $api } = useContext();
  const category = ref();
  const categoryAggs = ref();
  const categoryHeader = ref();
  const categoryContent = ref();
  const categoryProducts = ref();
  const pagesCount = ref();
  const { catalogNavItems, getCatalogNav } = useCatalogNav();
  const fetchCategory = async (slug, aggsQuery) => {
    const { getCategoryAggs } = useCategoryAggs();
    try {
      const { data } = await $api.categoriesService.getCategoryBySlug(slug, {
        ...aggsQuery,
        "includes": ["branch", "children"],
        // @ts-expect-error Need to fix types in CMS JS SDK
        "order[popular]": "desc"
      });
      if (!data)
        throw new Error("404 error");
      await getCatalogNav(data);
      category.value = data;
      categoryAggs.value = getCategoryAggs(category.value);
      categoryProducts.value = category.value?.products;
      categoryHeader.value = category.value.contents?.find(
        (block) => block.type === "catalog-head"
      )?.data;
      categoryContent.value = category.value.contents?.filter(
        (block) => block.type !== "catalog-head"
      );
      pagesCount.value = Math.ceil(
        Number(category.value?.products_meta_count) / aggsQuery.limit
      );
    } catch (e) {
      console.error("Fetch category failed: ", e);
      if (ssrContext)
        ssrContext.res.statusCode = 404;
      else error({ statusCode: 404 });
    }
  };
  return {
    fetchCategory,
    category,
    categoryAggs,
    categoryHeader,
    categoryContent,
    categoryProducts,
    catalogNavItems,
    pagesCount,
    getPageAggs
  };
}
var useFetchCategory_default = useFetchCategory;
export {
  useFetchCategory_default as default
};
